import Styled from "styled-components";

const PaginationWrapper = Styled.div`
 background-color: #FAFBFC;
 padding: 6px 16px;
 border-top: 1px solid #E8ECF1;
 border-radius: 0 0 10px 10px;
 .reload-btn{
  margin-left:10px;
 }
      .item-per-page{
        display: flex;
        align-items:center;
        grid-column-gap: 0px;
        .form-select-custom{
          position:relative;
          &::after{
                content:"";
                position: absolute;
                right: -10px;
                height: 24px;
                width:1px;
                top:6px;
                background: #E8ECF1;
            }
        }
        .form-select{
            width: 74px;
            border: none;
            background-color: transparent;
            font-size: 13px;
            color: #4E5969;
            cursor: pointer;
            &:focus{
              box-shadow: none;
              outline: none;
            }
        }
        span{
            color: #6B7280;
            font-size: 13px;
            &.per-page{
              margin-left: 7px;
            }
        }
        position: relative;

      }
      .total-items{
            margin-left: 26px;
    letter-spacing: 0.5px;
}
      .total-pages{
            margin-right: 17px;
    letter-spacing: 0.5px;
        .line-height{
              background: #E8ECF1;
              width:1px;
              height:20px;
              &.mr-12{
                margin-right:12px;
              }
            }
        .form-select{
            width: 65px;
            border: none;
            background-color: transparent;
            font-size: 13px;
            color: #4E5969;
            cursor: pointer;
            &:focus{
              box-shadow: none;
              outline: none;
            }
        }
             span{
            color: #6B7280;
            font-size: 13px;
            .pages{
              margin-right:24px;
            }
        }
            }
            .arrows{
             display: flex;
            grid-column-gap: 10px;
            align-items: center;
            svg{
              cursor: pointer;
              font-size: 18px;
              color: #6B7280;
              border-radius: 4px;
              transition: all 0.15s ease;
              &:hover{
                color: #1565D8;
                background: #F0F2F5;
              }
            }
            .line-height{
              background: #E8ECF1;
              width:1px;
              height:20px;
            }
            }

  /* Responsive: Hide items-per-page and total-pages on mobile */
  @media (max-width: 991px) {
    .pagination-inner {
      width: 100%;
    }

    .item-per-page {
      display: none !important;
    }

    .pagination-controls {
      margin-left: auto;
    }

    .total-pages {
      margin-right: 8px;
    }
  }
`;

export { PaginationWrapper };
